import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DisplayRelatedLinksComponent } from './display-related-links/display-related-links.component';
@NgModule({
  imports: [
    CommonModule
  ],
  declarations: [DisplayRelatedLinksComponent]
})
export class RelatedLinksModule { }



// WEBPACK FOOTER //
// ./src/app/related-links/related-links.module.ts